module.exports = "https://static.wmbcdn.com/uniweb/images/8c56e44c948356b1411d67261e0c5041.svg";